app.controller('OrderReplacementController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {


    $scope.waiting_for_data = true
    $scope.is_staff_view = false;
    $scope.staff_rep_customer_code = null;

    const replacementModel = $rootScope.model.order_replacement;
    const staffCustomerModel = $rootScope.model.staff_customer;
    let customerChoices = staffCustomerModel.choices;

    $scope.replacement_list_model = new $rootScope.model_constructor.ListModel({
        item_list: replacementModel.choiceList(),
        in_progress: true
    });
    applyCustomerChoices();

    let orderHistoryModel = $rootScope.service.order_history.getSubmittedModel()
    $scope.order_request_limit = orderHistoryModel.limit;
    $scope.replacement_request_limit = replacementModel.limit;



    $scope.order_archive_search_model = new $rootScope.model_constructor.SearchModel();
    $scope.order_archive_list_model = new $rootScope.model_constructor.ListModel();
    $scope.archiveSearch = function () {

        $scope.order_archive_search_model.prepare();
        $rootScope.service.order_history.requestArchive("order", $scope.order_archive_list_model, $scope.order_archive_search_model);
    };


    let documentProductTag = "replacement_order" ;
    $scope.replacement_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([documentProductTag], function (documents) {
        $scope.replacement_document = documents.length > 0 ? documents[0] : null;
    })

    function sortByGoneList(choiceList){

        choiceList.sort((a, b) => {
            if(a.status && a.status.toUpperCase() === "GONE"){
                return -1;
            }
            if(b.status && b.status.toUpperCase() === "GONE"){
                return 1;
            }
        })
        return choiceList;
    }

    $scope.order_list_model = new $rootScope.model_constructor.ListModel({
        item_list: !$scope.is_staff_view ? sortByGoneList(orderHistoryModel.choiceList()) : [],
        in_progress: true
    });


    function applyCustomerChoices()
    {
        if(!Object.keys(customerChoices).length){
            return;
        }

        for(let i = 0; i < $scope.replacement_list_model.item_list.length; i ++){
            const replacement = $scope.replacement_list_model.item_list[i];
            const customerChoice = replacement.customer_code ? customerChoices[replacement.customer_code] : null;
            if(customerChoice){
                replacement.customer = customerChoice;
            }
        }
    }


    staffCustomerModel.requestCustomers(function () {
        customerChoices = staffCustomerModel.choices;
        applyCustomerChoices();
    })

    $scope.getCustomerChoice = function (customerID) {
        return customerChoices[customerID] ?? {};
    }

    replacementModel.requestReplacementList(function () {
        $scope.replacement_list_model.cloneList(replacementModel.choiceList());
        applyCustomerChoices();
    })


    $rootScope.service.account.requireUserData(function () {
        $scope.waiting_for_data = false
        $scope.is_staff_view = $rootScope.model.staff.is_staff_or_rep;

        if($scope.is_staff_view){
            $scope.staff_rep_customer_code = $rootScope.model.staff.staff_rep_customer_code;
            if(!$scope.staff_rep_customer_code){
                return;
            }
            orderHistoryModel = $rootScope.service.order_history.getSubmittedModel(0, $scope.staff_rep_customer_code);
        }
        orderHistoryModel.requestOrders(function () {
            $scope.order_list_model.cloneList(sortByGoneList(orderHistoryModel.choiceList()));
        })
    });

}]);
